import type currency from 'currency.js'
import * as React from 'react'
import type { ViewProps } from 'react-native'
import { LiveNeedCardView } from './LiveNeedCardView'
import { LoadingNeedCardView } from './LoadingNeedCardView'
import { MetNeedCardView } from './MetNeedCardView'

interface BaseProps {
  status: 'loading' | 'success' | 'error'
  containerProps?: ViewProps
}

interface LoadingProps extends BaseProps {
  status: 'loading'
}

interface ErroredProps extends BaseProps {
  status: 'error'
  error: Error
}

interface SuccessProps extends BaseProps {
  status: 'success'
  id: number

  organizationName: string
  organizationProfileImagePath: string

  title: string
  shortDescription: string

  priceIncludingTip: currency.Any
  city?: string
  state?: string

  isMet?: boolean
  hasThankYou?: boolean
  userMetThisNeed?: boolean
  urgent?: boolean
  picture_path?: string | null

  disabled?: boolean
}

export type NeedCardViewProps = Prettify<
  LoadingProps | ErroredProps | SuccessProps
>

export function NeedCardView(props: NeedCardViewProps) {
  if (props.status === 'loading' || props.status === 'error') {
    return <LoadingNeedCardView />
  }

  return props.isMet ? (
    <MetNeedCardView
      id={props.id}
      organizationName={props.organizationName}
      title={props.title}
      shortDescription={props.shortDescription}
      priceIncludingTip={props.priceIncludingTip}
      city={props.city}
      state={props.state}
      hasThankYou={props.hasThankYou}
      userMetThisNeed={props.userMetThisNeed}
      containerProps={props.containerProps}
      picture_path={props.picture_path}
    />
  ) : (
    <LiveNeedCardView
      id={props.id}
      organizationImagePath={props.organizationProfileImagePath}
      organizationName={props.organizationName}
      title={props.title}
      shortDescription={props.shortDescription}
      priceIncludingTip={props.priceIncludingTip}
      city={props.city}
      state={props.state}
      urgent={props.urgent}
      containerProps={props.containerProps}
      picture_path={props.picture_path}
    />
  )
}
